import { FC } from 'react'
import { useTranslation } from 'react-i18next'

import { ErrorPage } from '@liveconnect/events-ui'

export const UnknownError: FC = () => {
  const { t } = useTranslation()

  return (
    <ErrorPage className="unknown-error">
      <>
        <ErrorPage.Icon name="report_problem" />

        <ErrorPage.Title text={t('pageError.unknownError.title')} />
        <ErrorPage.Body text={t('pageError.unknownError.body')} />
      </>
    </ErrorPage>
  )
}
